// =======================================================
// audio/dive_audio.js
// =======================================================

var URL_GLOBAL = "https://cozumel-reef-maps.com.mx";

// =======================================================
// 🎧 ESTADO GLOBAL
// =======================================================

let homeAudio = null;
let enabled_home = false;

// =======================================================
// 🤿 AUDIO DE BUCEO
// =======================================================



// =======================================================
// 🏠 AUDIO HOME
// =======================================================

export function initHomeAudio() {
  homeAudio = new Audio(URL_GLOBAL + "/Views/Default/audio/base_mapas.mp3");
  homeAudio.loop = true;
  homeAudio.volume = 0.35;
  homeAudio.muted = true; // iOS safe
  enabled_home = true;
}

export function startHomeAudio() {
  if (!enabled_home || !homeAudio) return;

  homeAudio.currentTime = 0;
  homeAudio.play().catch(() => {
    console.warn("🔇 Home audio blocked (needs user interaction)");
  });
}

export function stopHomeAudio() {
  if (!homeAudio) return;

  homeAudio.pause();
  homeAudio.currentTime = 0;
}

// =======================================================
// 🎚️ CONTROLES DE AUDIO HOME (MUTE + VOLUMEN)
// =======================================================







export function createHomeAudioControls() {
  if (!homeAudio) return null;

  // 1. Crear e inyectar los estilos CSS (incluyendo Media Queries)
  // Solo los creamos si no existen ya en la página
  if (!document.getElementById("home-audio-styles")) {
    const styleTag = document.createElement("style");
    styleTag.id = "home-audio-styles";
    styleTag.textContent = `
      .audio-controls-container {
        position: fixed;
        top: 105px; /* Por defecto en móviles */
        left: 5px;
        background: rgb(255 255 255 / 0%);
        backdrop-filter: blur(10px);
        border-radius: 5px;
        padding: 10px 12px;
        display: flex;
        align-items: center;
        z-index: 99999;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 8px 24px;
        user-select: none;
        height: 20px;
        transform: scale(1); /* Escala base */
        transform-origin: top left;
        transition: top 0.2s, transform 0.2s; /* Suaviza el cambio */
      }

      /* 📱 Pantallas medianas (Tablets) */
      @media (min-width: 768px) {
        .audio-controls-container {
          top: 140px;          /* Más margen superior */
          transform: scale(1.2); /* 20% más grande */
        }
      }

      /* 💻 Pantallas grandes (Desktops) */
      @media (min-width: 1200px) {
        .audio-controls-container {
          top: 180px;          /* Aún más margen superior */
          transform: scale(1.4); /* 40% más grande */
        }
      }

      .audio-mute-btn {
        border: none;
        background: none;
        font-size: 20px;
        cursor: pointer;
        padding: 0 2px;
      }

      .audio-volume-slider {
        width: 96px;
        accent-color: #007aff;
      }
    `;
    document.head.appendChild(styleTag);
  }

  // 2. Crear los elementos y asignarles sus respectivas clases
  const audioControls = document.createElement("div");
  audioControls.className = "audio-controls-container";

  const muteBtn = document.createElement("button");
  muteBtn.className = "audio-mute-btn";
  muteBtn.textContent = "🔇";

  const volumeSlider = document.createElement("input");
  volumeSlider.className = "audio-volume-slider";
  volumeSlider.type = "range";
  volumeSlider.min = 0;
  volumeSlider.max = 1;
  volumeSlider.step = 0.01;
  volumeSlider.value = homeAudio.volume;

  // -------------------------------
  // 🔓 iOS UNLOCK AUDIO
  // -------------------------------
  const unlockAudio = () => {
    homeAudio.muted = false;
    muteBtn.textContent = "🔊";

    startHomeAudio(); 

    const overlay = document.getElementById("home-audio-overlay");
    if (overlay) overlay.remove(); 

    document.removeEventListener("click", unlockAudio);
    document.removeEventListener("touchstart", unlockAudio);
  };

  document.addEventListener("click", unlockAudio, { once: true });
  document.addEventListener("touchstart", unlockAudio, { once: true });

  // -------------------------------
  // 🔇 TOGGLE MUTE
  // -------------------------------
  muteBtn.onclick = (e) => {
    e.stopPropagation();
    homeAudio.muted = !homeAudio.muted;
    muteBtn.textContent = homeAudio.muted ? "🔇" : "🔊";
  };

  // -------------------------------
  // 🔊 VOLUMEN
  // -------------------------------
  volumeSlider.oninput = (e) => {
    e.stopPropagation();
    homeAudio.volume = Number(e.target.value);

    if (homeAudio.volume > 0) {
      homeAudio.muted = false;
      muteBtn.textContent = "🔊";
    }
  };

  volumeSlider.addEventListener("pointerdown", (e) => e.stopPropagation());

  audioControls.appendChild(muteBtn);
  audioControls.appendChild(volumeSlider);

  return audioControls;
}





// =======================================================
// 🎵 FADE OUT SUAVE (HOME)
// =======================================================

export function fadeOutHomeAudio() {
  if (!homeAudio) return;

  let v = homeAudio.volume;

  const fadeOut = setInterval(() => {
    v -= 0.03;
    homeAudio.volume = Math.max(v, 0);

    if (v <= 0) {
      clearInterval(fadeOut);
      homeAudio.pause();
      homeAudio.currentTime = 0;
    }
  }, 40);
}

// =======================================================
// 🖥️ OVERLAY FULLSCREEN (HOME)
// =======================================================

export function createHomeOverlay() {
  const overlay = document.createElement("div");
  overlay.id = "home-audio-overlay";

  overlay.style = `
    position: fixed;
    inset: 0;
    background: transparent;          /* 🔥 sin cielo azul */
    z-index: 2147483646;
    cursor: pointer;
  `;

  return overlay;
}
